import React from 'react'
import { NavLink } from 'react-router-dom';
// import SvgIcon from './SvgIcon';

const NavLinks = () => {
    return (
        <NavLink to='' key='home' activeClassName="bg-ltgreen text-white" className="text-gray-600 group flex items-center px-2 py-2 text-sm font-medium rounded-md hover:bg-ltgreen hover:text-black">
            {/* <SvgIcon movePath={link.svg} /> */}
                Home
        </NavLink>
    )
}

export default NavLinks
